import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { formatDate as fmtDateUtil } from '../../utils/dateUtils';
import { LoadingState, DonutChart, BarGraph, ReportTable, fmt } from './ReportHelpers';

const fmtDate = (d) => fmtDateUtil(d);

export function QuotesTab({ data, loading, openOnly, setOpenOnly, onExport }) {
  if (loading) return <LoadingState />;
  if (!data) return null;
  const handleExport = () => {
    const headers = ['Quote No.', 'Date', 'Client', 'Address', 'Job Titles', 'Status', 'Subtotal', 'GST', 'Total'];
    const rows = data.items.map(r => [r.quote_number, r.date, r.client_name, r.address, r.job_titles, r.status, r.subtotal, r.gst, r.total]);
    const summary = ['', '', '', '', '', 'TOTAL', '', '', data.grand_total];
    onExport('Quote Report', headers, rows, summary);
  };
  return (
    <div className="space-y-4" data-testid="quotes-tab">
      <div className="flex items-center justify-between print:hidden">
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <input type="checkbox" checked={openOnly} onChange={e => setOpenOnly(e.target.checked)} className="rounded" data-testid="open-only-check" />
          Open quotes only (For Acceptance)
        </label>
        <button onClick={handleExport} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700" data-testid="export-quotes-excel">
          <FileSpreadsheet size={14} /> Export Excel
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <DonutChart data={data.by_status} title="Quote Status Distribution" />
        <BarGraph data={data.by_status} title="Quotes by Status" />
      </div>
      <ReportTable
        headers={['Quote No.', 'Date', 'Client', 'Address', 'Job Titles', 'Status', 'Subtotal', 'GST', 'Total']}
        rows={data.items.map(r => [r.quote_number, fmtDate(r.date), r.client_name, r.address, r.job_titles, r.status, fmt(r.subtotal), fmt(r.gst), fmt(r.total)])}
        footer={['', '', '', '', '', 'TOTAL', '', '', fmt(data.grand_total)]}
        testId="quotes-table"
      />
    </div>
  );
}
